module.exports = __webpack_public_path__ + "static/media/19-2.9eb84726.mp3";